package com.advaita.cloud.drive.ui.api

/**
 * ADV-1330: a non-2xx answer from a share route, with its typed body. Every share route answers
 * `{"error": <code>, "retryable": "true" | "false"}`, and a few answer with no body at all (a
 * `404`). The UI reads [status] and [code] to choose between a cap (a disabled control with one
 * sentence, S8) and an error message. The exception's own message stays technical, for the
 * console, and carries no name or email.
 */
class ShareApiException(
    val status: Int,
    val code: String?,
    val retryAfterSeconds: Int? = null,
) : RuntimeException("share call failed: HTTP $status ${code ?: ""}".trim())

